import React from 'react';
import { IconButton } from 'theme-ui';

function ExplorerCollapseIconOpen() {
  return (
    <IconButton>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M14 16l-4-4 4-4"
          opacity="0.4"
        />
      </svg>
    </IconButton>
  );
}
export default ExplorerCollapseIconOpen;
